// extracted by mini-css-extract-plugin
module.exports = {"desktop":"full-bleed-image_desktop__LNB8B","mobile":"full-bleed-image_mobile__13ru_"};